import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { ChevronRight } from 'react-bootstrap-icons';
import { getUpdateNotes } from '../services/UpdateNotesService';
import { SidebarWidget } from './SidebarWidget/SidebarWidget';

export function UpdateNotes() {
  const [updateNotes, setUpdateNotes] = useState([]);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const notes = await getUpdateNotes();
        if (!cancelled) setUpdateNotes(notes);
      } catch {
        // sidebar widget — fail silently
      }
    }

    load();
    return () => { cancelled = true; };
  }, []);

  const sorted = [...updateNotes]
    .sort((a, b) => new Date(b.Date) - new Date(a.Date))
    .slice(0, 5);

  return (
    <SidebarWidget title="Update Notes">
      {sorted.map(note => (
        <LinkContainer
          key={note.ID}
          exact
          to={`/updates/${note.ID}/${note.Title.replaceAll(' ', '-')}`}
        >
          <div className="sw-nav-item">
            <span className="sw-nav-date">
              {new Date(note.Date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
            </span>
            <span className="sw-nav-text">{note.Title}</span>
            <ChevronRight className="sw-nav-arrow" />
          </div>
        </LinkContainer>
      ))}
      <div className="sw-nav-footer">
        <Link className="sw-nav-footer-link" to="/updates">View All →</Link>
      </div>
    </SidebarWidget>
  );
}
